<template>
  <div :id="domId" :style="{ width: '100%', height: '100%' }"></div>
</template>

<script>
export default {
  name: 'scholarHotWord',
  props: ['hotData', 'domId'],
  data() {
    return {};
  },
  created() {
    if (this.domId === 'detail') {
      this.$nextTick(() => {
        this.getOption();
      });
    }
  },
  watch: {
    hotData: {
      handler() {
        this.getOption();
      },
    },
  },
  methods: {
    toSearch(hotWord) {
      this.$router.push({ path: '/talentSearch', query: { searchValue: hotWord } });
    },

    getOption() {
      this.hotWord = this.$echarts.init(document.getElementById(this.domId));
      this.hotWord.setOption({
        tooltip: {
          show: false,
        },
        series: [
          {
            name: '搜索指数',
            type: 'wordCloud',
            //size: ['9%', '99%'],
            sizeRange: [12, 28],
            //textRotation: [0, 45, 90, -45],
            rotationRange: [-45, 90],
            //shape: 'circle',
            textPadding: 0,
            autoSize: {
              enable: true,
              minSize: 3,
            },
            textStyle: {
              normal: {
                color: function () {
                  return (
                    'rgb(' +
                    [
                      Math.round(Math.random() * 255),
                      Math.round(Math.random() * 255),
                      Math.round(Math.random() * 255),
                    ].join(',') +
                    ')'
                  );
                },
              },
              emphasis: {
                shadowBlur: 10,
                shadowColor: '#333',
              },
            },
            data: this.hotData,
          },
        ],
      });
      this.hotWord.off('click');
      this.hotWord.off('mouseover');
      let that = this;
      this.hotWord.on('click', function (p) {
        that.toSearch(p.data.name);
      });
      window.addEventListener('resize', () => {
        this.hotWord.resize();
      })
    },
  },
};
</script>

<style scoped></style>
